__turbopack_context__.v({
  "accent": "ZApqXG_accent",
  "checkbox": "ZApqXG_checkbox",
  "container": "ZApqXG_container",
  "description": "ZApqXG_description",
  "dots": "ZApqXG_dots",
  "form": "ZApqXG_form",
  "formRow": "ZApqXG_formRow",
  "iconMail": "ZApqXG_iconMail",
  "input": "ZApqXG_input",
  "mainAccent": "ZApqXG_mainAccent",
  "noSpam": "ZApqXG_noSpam",
  "overflow": "ZApqXG_overflow",
  "subscribeButton": "ZApqXG_subscribeButton",
  "title": "ZApqXG_title",
});
